export const CopyQRCodeId = {
    SET_CopyQRCodeIdData: "SET_CopyQRCodeIdData",
}